const l = {
  name: "ClassicIntegration",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,0v5c3.2,0.2,6.3,1.4,8.9,3.7l3.6-3.6l1.4,1.4l-3.6,3.6c2.2,2.6,3.5,5.7,3.7,8.9h5v2h-5
			c-0.2,3.2-1.4,6.3-3.7,8.9l3.6,3.6l-1.4,1.4l-3.6-3.6c-2.6,2.2-5.7,3.5-8.9,3.7v5h-2v-5c-3.2-0.2-6.3-1.4-8.9-3.7l-3.6,3.6
			l-1.4-1.4l4.9-4.9l0.7,0.7c5.1,5.1,13.3,5.1,18.4,0s5.1-13.3,0-18.4c-5.1-5.1-13.3-5.1-18.4,0l-0.7,0.7L5.2,6.6l1.4-1.4l3.6,3.6
			C12.7,6.5,15.8,5.2,19,5V0H21z"/>
		<path class="st0" d="M25.7,14.3c-3.1-3.1-8.2-3.1-11.3,0l-1.4-1.4c3.9-3.9,10.2-3.9,14.1,0c3.9,3.9,3.9,10.2,0,14.1
			c-3.9,3.9-10.2,3.9-14.1,0l1.4-1.4c3.1,3.1,8.2,3.1,11.3,0C28.8,22.5,28.8,17.5,25.7,14.3z"/>
		<path class="st0" d="M19.6,21H0v-2h19.6l-2.3-2.3l1.4-1.4l4.7,4.7l-4.7,4.7l-1.4-1.4L19.6,21z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as ClassicIntegration
};
